import { useSelector, useDispatch } from "react-redux";
import { selectMachine } from "../../store/slices/machine-slice";

import clsx from "clsx";
import CheckBoxGold from "~/assets/checkbox-gold.svg";
import CheckBoxGrey from "~/assets/checkbox-grey.svg";
import "./MachineSelection.css";

const MachineSelection = () => {
  const machine = useSelector((state) => state.machine.machine);

  const dispatch = useDispatch();

  return (
    <div className={clsx("section", { "machine-need-selected": machine === "need" })}>
      <h2>1. Choose Your Machine</h2>
      <div className="machine-options">
        <button
          onClick={() => dispatch(selectMachine("need"))}
          className={clsx({ selected: machine === "need" })}>
          I need a machine
          {/* <div className="machine-option-checkbox">
            {machine === "need" ? <CheckBoxGold /> : <CheckBoxGrey />}
          </div> */}
        </button>
        <button
          onClick={() => dispatch(selectMachine("have"))}
          className={clsx({ selected: machine === "have" })}>
          I already have a machine
          {/* <div className="machine-option-checkbox">
            {machine === "have" ? <CheckBoxGold /> : <CheckBoxGrey />}
          </div> */}
        </button>
      </div>
    </div>
  );
};

export default MachineSelection;
